"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccordionHeader = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Typography = require("../../Typography");

var _Icon = require("../../Icon");

var styles = {
  "Accordion": "Accordion__Accordion___2vsT6",
  "AccordionItem": "Accordion__AccordionItem___11w9U",
  "Accordion--start": "Accordion__Accordion--start___2hNCQ",
  "AccordionHeader": "Accordion__AccordionHeader___3k1Uh",
  "Accordion--end": "Accordion__Accordion--end___1WaCd",
  "AccordionHeader--expanded": "Accordion__AccordionHeader--expanded___Zmyij",
  "AccordionHeader__icon": "Accordion__AccordionHeader__icon___1pUm4"
};

var AccordionHeader = function AccordionHeader(_ref) {
  var children = _ref.children,
      handleClick = _ref.handleClick,
      _ref$isExpanded = _ref.isExpanded,
      isExpanded = _ref$isExpanded === void 0 ? false : _ref$isExpanded,
      ariaId = _ref.ariaId,
      _ref$element = _ref.element,
      element = _ref$element === void 0 ? 'h2' : _ref$element;
  var classNames = (0, _classnames["default"])(styles.AccordionHeader, (0, _defineProperty2["default"])({}, styles['AccordionHeader--expanded'], isExpanded));
  return /*#__PURE__*/_react["default"].createElement(_Typography.Subheading, {
    element: element
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    "aria-expanded": isExpanded,
    "aria-controls": "accordion-panel--".concat(ariaId),
    id: "accordion--".concat(ariaId),
    className: classNames,
    onClick: handleClick
  }, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    icon: "ChevronDownTrimmed",
    color: "secondary",
    className: styles.AccordionHeader__icon
  }), children));
};

exports.AccordionHeader = AccordionHeader;